import { useEffect, useState } from 'react';
import Loader from '../Common/Loader';
import blankImage from '../../Assets/NoPhoto.jpg';
import { Link, useNavigate, useParams } from 'react-router-dom';
import ManufacturerApi from '../../Api/ManufacturerApi';
import { Manufacturer } from '../../Models/Manufacturer';
import { SelectOption } from '../../Models/SelectOption';
import { FileTypeEnums } from '../../Models/FileType';

export default function ManufacturersDisplay() {
  const navigate = useNavigate();
  const [manufacturerWGData, setManufacturerWGData] = useState<
    Manufacturer[] | null
  >();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getManufacturers = () => {
    setIsLoading(true);
    ManufacturerApi.getManufacturerListWG()
      .then((res) => {
        setManufacturerWGData(
          res.data.filter((item) => item.rimssOemvendorNumber?.startsWith('1') && item.active == true)
        );
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    setTimeout(() => {
      getManufacturers();
    }, 100);
  }, []);

  const handleManufacturerClick = (manufacturer: Manufacturer | null) => {
    localStorage.setItem('manufacturersState', '');
    localStorage.setItem('categoriesState', '');
    localStorage.setItem('subCategoriesState', '');
    localStorage.setItem('searchTextState', '');
    localStorage.setItem('minPriceState', '');
    localStorage.setItem('maxPriceState', '');
    localStorage.setItem('equipmentTypeState', '');
    if (manufacturer) {
      const manufacturerValues = {
        label: manufacturer.name,
        value: manufacturer.id,
      };
      localStorage.setItem(
        'manufacturersState',
        JSON.stringify([manufacturerValues as SelectOption])
      );
      navigate(`/manufacturer/${manufacturer.id}/products`);
    }
  };

  return (
    <>
      <div className='w-full mt-4'>
        <div className='container mx-auto p-2'>
          <div className='mb-2 border-b-2'>
            <h1 className='text-gray-900 font-bold text-4xl'>Manufacturers</h1>
          </div>
          <div className='relative'>
            {isLoading && <Loader />}
            {manufacturerWGData && (
              <div className='flex flex-wrap gap-10 justify-center h-[calc(100vh-142px)] md:h-[calc(100vh-210px)] overflow-y-auto'>
                {manufacturerWGData
                  .sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''))
                  .map((manufacturer) => (
                    <div
                      key={manufacturer.id}
                      className='w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/6 flex justify-center'
                    >
                      <button
                        onClick={() => handleManufacturerClick(manufacturer)}
                      >
                        <div className='flex rounded-lg border border-gray-200 bg-gray-100 shadow-md dark:border-gray-700 dark:bg-gray-800 flex-col max-w-sm mx-auto p-0'>
                          <div className='self-center'>
                            <img
                              key={manufacturer.id}
                              src={
                                manufacturer.files &&
                                manufacturer.files?.filter(
                                  (x) => x.fileTypeId === FileTypeEnums.Photo
                                ).length > 0
                                  ? manufacturer.files.filter(
                                      (x) =>
                                        x.fileTypeId === FileTypeEnums.Photo
                                    )[0].fileUrl
                                  : blankImage
                              }
                              alt={manufacturer.name + '-image'}
                              className='h-[200px] object-contain'
                            />
                          </div>
                          <div className='flex h-full flex-col justify-center p-6'>
                            <h5 className='text-xl font-bold tracking-tight text-gray-900 text-center'>
                              {manufacturer.name!}
                            </h5>
                            <h5 className='tracking-tight text-gray-900 text-center'>
                              {manufacturer.rimssOemvendorNumber!}
                            </h5>
                          </div>
                        </div>
                      </button>
                    </div>
                  ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
